<div class="progress-bar-container">
  <div class="progress-bar" [ngClass]="{ 'loading': loading }" [style.width.%]="!loading ? value : 100"></div>
</div>
